// extracted by mini-css-extract-plugin
module.exports = {"photo":"Personal_photo__33qiE"};